import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import CoachLayout from "../common/CoachLayout";
import { useCoachAuthContext } from "../login/useCoachAuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { CoachHeader } from "../common/CoachHeader";
import API_URL from "../../api/API";
import "chart.js/auto";

// Arrow component for the dropdown
const ArrowD = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
    <path d="M13 1L7 7L1 1" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CoachLoadvelocityPerformance = () => {
  const { coach } = useCoachAuthContext();
  const { template_id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [performanceData, setPerformanceData] = useState({});
  const [openIndex, setOpenIndex] = useState(null); // To track the open/closed sections
  const trainingFocuses = ["Technical", "Speed - Strength", "Power", "Strength - Speed"];

  useEffect(() => {
    const fetchPerformanceData = async () => {
      try {
        const data = {};
        for (const focus of trainingFocuses) {
          const response = await fetch(
            API_URL.GET_COACH_LOADVELOCITY_PERFORMANCE + coach.id + "/" + focus,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${coach.token}`,
              },
            }
          );
          if (!response.ok) throw new Error("Failed to fetch " + focus + " data");
          const result = await response.json();
          console.log(result);
          data[focus] = result.data;
        }
        setPerformanceData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPerformanceData();
  }, [coach.id]);

  const prepareChartData = (focus) => {
    const weeks = Object.keys(performanceData[focus] || {}).sort();
  
    // Prepare the data by iterating over each week and day
    const sortedData = weeks.flatMap((week) =>
      performanceData[focus][week].map((day) => ({
        day: `${week}`,
        speedData: day.speed_data // This contains multiple speed values for a given day
      }))
    );
  
    // Flatten the data to get all the individual speed values
    const chartData = sortedData.flatMap((entry) => 
      entry.speedData.map((speedValue) => ({
        label: entry.day, // Keeping the week-day label
        speed: speedValue  // Each individual speed value
      }))
    );
  
    return {
      labels: chartData.map((entry) => entry.label), // Labels for x-axis (week-day)
      datasets: [
        {
          label: `${focus} Speed Data`,
          data: chartData.map((entry) => entry.speed), // Flattened speed values
          borderColor: "#000",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      ],
    };
  };
  

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle accordion open/close
  };

  return (
    <CoachLayout>
      <div className="bg-[#f6f6f6] h-full">
        <div className="bg-white">
          <CoachHeader />
        </div>
        <div className="relative h-full bg-[#f6f6f6] pb-5 overflow-y-auto">

        <div className="bg-[#F6F6F6]">
            <div className="w-full max-w-2xl mx-auto flex flex-row justify-between gap-5 px-10 py-[19px]">
              <span onClick={() => navigate("/coach/tools/loadvelocity/test/result")} className="text-base font-normal pb-[4px] text-[#a5a5a5] cursor-pointer">
                Test
              </span>
              <span onClick={() =>  navigate("/coach/tools/loadvelocity/training-weeks/" + template_id)} className="text-base font-normal pb-[4px] text-[#a5a5a5] cursor-pointer">
                Train
              </span>
              <span className="text-base font-normal pb-[4px] text-black border-b border-black ">
                Performance
              </span>
              
            </div>
          </div>  




          <div className="w-full max-w-2xl mx-auto mb-[30px]">
            {trainingFocuses.map((focus, index) => (
              <div
                key={index}
                className={`relative border-b border-black/20 last:border-none ${
                  openIndex === index && "!border-none"
                }`}
              >
                <div
                  className={`${
                    openIndex === index && "!bg-[#ECECEC]"
                  } flex flex-col py-[15px] px-5 bg-transparent cursor-pointer`}
                >
                  <button
                    className="text-black text-start text-base font-normal flex flex-row justify-between gap-3 items-center"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span>{focus.replace(/([A-Z])/g, " $1").trim()}</span>
                    <span className={openIndex === index ? "rotate-180" : ""}>
                      <ArrowD />
                    </span>
                  </button>

                  {openIndex === index && (
                    <div className="pt-[15px] h-[233px] pb-3">
                      {isLoading ? (
                        <p>Loading...</p>
                      ) : error ? (
                        <p className="text-red-500">{error}</p>
                      ) : (
                        <Line data={prepareChartData(focus)} />
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </CoachLayout>
  );
};

export default CoachLoadvelocityPerformance;
